import React, { useEffect, useState } from "react";
import Buttons from "../../common/Buttons";
import InputFiels from "../../common/InputFiels";
import Checkbox from "../../common/Checkbox";
import ProDetails from "./ProDetails";
import MultiBar from "../../common/MultiBar";

// function classNames(...classes) {
//     return classes.filter(Boolean).join(' ')
// }

const list = [
  {
    label: "Add Site",
    icon: (
      <React.Fragment>
        <div className="mr-2">
          <span class="material-icons text-scogogray">domain</span>
        </div>
      </React.Fragment>
    ),
  },
];

let cardSize = "lg:w-1/4";

const profile = ["Your Profile", "Settings", "Sign out"];

const projectList = [
  {
    projectID: "P-CSNC-CS-000200",
    projectName: "Demo_Support",
    ticketDate: "Mon, June 28 4:44 PM",
    totalTickets: "30",
    customerBank: "ICICI Bank",
    customerName: "Adam Clark",
    customerNumber: "9898123456",
    performanemin: "2 days",
    performanemavg: "2.5 days",
    performanemax: "4 days",
    performane: "loren lipsum",
    spocmin: "2 days",
    spocNumber: "9898123456",
    ProDetails: "Customer Support",
    pmName: "David Miller",
    pmNumber: "9898123456",
    ongoin: 5,
    hold: 80,
    closed: 15,
    totalPercentage: 40
  },

  {
    projectID: "P-CSNC-CS-0002",
    projectName: "Demo_Support",
    ticketDate: "Mon, June 28 4:44 PM",
    totalTickets: "30",
    customerBank: "ICICI Bank",
    customerName: "Adam Clark",
    customerNumber: "9898123456",
    performanemin: "2 days",
    performanemavg: "2.5 days",
    performanemax: "4 days",
    performane: "loren lipsum",
    spocmin: "2 days",
    spocNumber: "9898123456",
    ProDetails: "Customer Support",
    pmName: "David Miller",
    pmNumber: "9898123456",
    ongoin: 5,
    hold: 80,
    closed: 15,
    totalPercentage: 40
  },

  {
    projectID: "P-CSNC-CS-0002",
    projectName: "Demo_Support",
    ticketDate: "Mon, June 28 4:44 PM",
    totalTickets: "30",
    customerBank: "ICICI Bank",
    customerName: "Adam Clark",
    customerNumber: "9898123456",
    performanemin: "2 days",
    performanemavg: "2.5 days",
    performanemax: "4 days",
    performane: "loren lipsum",
    spocmin: "2 days",
    spocNumber: "9898123456",
    ProDetails: "Customer Support",
    pmName: "David Miller",
    pmNumber: "9898123456",
    ongoin: 5,
    hold: 80,
    closed: 15,
    totalPercentage: 40
  },


  {
    projectID: "P-CSNC-CS-0002",
    projectName: "Demo_Support",
    ticketDate: "Mon, June 28 4:44 PM",
    totalTickets: "30",
    customerBank: "ICICI Bank",
    customerName: "Adam Clark",
    customerNumber: "9898123456",
    performanemin: "2 days",
    performanemavg: "2.5 days",
    performanemax: "4 days",
    performane: "loren lipsum",
    spocmin: "2 days",
    spocNumber: "9898123456",
    ProDetails: "Customer Support",
    pmName: "David Miller",
    pmNumber: "9898123456",
    ongoin: 5,
    hold: 80,
    closed: 15,
    totalPercentage: 40
  },


  {
    projectID: "P-CSNC-CS-0002",
    projectName: "Demo_Support",
    ticketDate: "Mon, June 28 4:44 PM",
    totalTickets: "30",
    customerBank: "ICICI Bank",
    customerName: "Adam Clark",
    customerNumber: "9898123456",
    performanemin: "2 days",
    performanemavg: "2.5 days",
    performanemax: "4 days",
    performane: "loren lipsum",
    spocmin: "2 days",
    spocNumber: "9898123456",
    ProDetails: "Customer Support",
    pmName: "David Miller",
    pmNumber: "9898123456",
    ongoin: 5,
    hold: 80,
    closed: 15,
    totalPercentage: 40
  },


  {
    projectID: "P-CSNC-CS-0002",
    projectName: "Demo_Support",
    ticketDate: "Mon, June 28 4:44 PM",
    totalTickets: "30",
    customerBank: "ICICI Bank",
    customerName: "Adam Clark",
    customerNumber: "9898123456",
    performanemin: "2 days",
    performanemavg: "2.5 days",
    performanemax: "4 days",
    performane: "loren lipsum",
    spocmin: "2 days",
    spocNumber: "9898123456",
    ProDetails: "Customer Support",
    pmName: "David Miller",
    pmNumber: "9898123456",
    ongoin: 5,
    hold: 80,
    closed: 15,
    totalPercentage: 40
  },


  {
    projectID: "P-CSNC-CS-0002",
    projectName: "Demo_Support",
    ticketDate: "Mon, June 28 4:44 PM",
    totalTickets: "30",
    customerBank: "ICICI Bank",
    customerName: "Adam Clark",
    customerNumber: "9898123456",
    performanemin: "2 days",
    performanemavg: "2.5 days",
    performanemax: "4 days",
    performane: "loren lipsum",
    spocmin: "2 days",
    spocNumber: "9898123456",
    ProDetails: "Customer Support",
    pmName: "David Miller",
    pmNumber: "9898123456",
    ongoin: 5,
    hold: 80,
    closed: 15,
    totalPercentage: 40
  },


  {
    projectID: "P-CSNC-CS-0002",
    projectName: "Demo_Support",
    ticketDate: "Mon, June 28 4:44 PM",
    totalTickets: "30",
    customerBank: "ICICI Bank",
    customerName: "Adam Clark",
    customerNumber: "9898123456",
    performanemin: "2 days",
    performanemavg: "2.5 days",
    performanemax: "4 days",
    performane: "loren lipsum",
    spocmin: "2 days",
    spocNumber: "9898123456",
    ProDetails: "Customer Support",
    pmName: "David Miller",
    pmNumber: "9898123456",
    ongoin: 5,
    hold: 80,
    closed: 15,
    totalPercentage: 40
  },


  {
    projectID: "P-CSNC-CS-0002",
    projectName: "Demo_Support",
    ticketDate: "Mon, June 28 4:44 PM",
    totalTickets: "30",
    customerBank: "ICICI Bank",
    customerName: "Adam Clark",
    customerNumber: "9898123456",
    performanemin: "2 days",
    performanemavg: "2.5 days",
    performanemax: "4 days",
    performane: "loren lipsum",
    spocmin: "2 days",
    spocNumber: "9898123456",
    ProDetails: "Customer Support",
    pmName: "David Miller",
    pmNumber: "9898123456",
    ongoin: 5,
    hold: 80,
    closed: 15,
    totalPercentage: 40
  },


  {
    projectID: "P-CSNC-CS-000200",
    projectName: "Demo_Support",
    ticketDate: "Mon, June 28 4:44 PM",
    totalTickets: "30",
    customerBank: "ICICI Bank",
    customerName: "Adam Clark",
    customerNumber: "9898123456",
    performanemin: "2 days",
    performanemavg: "2.5 days",
    performanemax: "4 days",
    performane: "loren lipsum",
    spocmin: "2 days",
    spocNumber: "9898123456",
    ProDetails: "Customer Support",
    pmName: "David Miller",
    pmNumber: "9898123456",
    ongoin: 5,
    hold: 80,
    closed: 15,
    totalPercentage: 40
  },


];

const Dashboard = () => {
  const [openTab, setOpenTab] = React.useState(1);
  const [isUserOpen, setIsUserOpen] = React.useState(false);
  const [projectDetails, setProjectDetails] = React.useState(false);
  const [mainDiv, setMainDiv] = React.useState("");
  const [bguser, setBguser] = React.useState("");

  const [search, Setsearch] = useState([
    {
      searchUser: "",
    },
  ]);

  const handleChange = () => { };


  const closeProjectDetails = () => {
    setProjectDetails(false);
    setMainDiv("")
      setBguser("")
  };

  const openDetails = () => {
    if (projectDetails) {
      setProjectDetails(false);
      setMainDiv("")
      setBguser("")
    } else {
      setProjectDetails(true);
      // setIsUserOpen(false);
      setMainDiv("lg:w-2/3 hidden")
    }
  };

  const viemore = () => {

  }

  const closeProSide = () => {
    setProjectDetails(false)
    setMainDiv("")
  }

  useEffect(() => {
    closeProSide()
    closeProjectDetails()
  }, [])

  return (
    <div className="lg:flex relative">
      <div className={`h-full w-full lg:block pb-5 md:pt-0 pt-16 ${mainDiv}`}>
        {/* <div className="bg-scogof8 h-full md:w-2/3 w-full"> */}
        <div className="sticky top-16 w-full 2xl:px-8 xl:px-4 px-2 md:pt-8 pt-2 md:pb-4 pb-0 bg-scogof8 z-20">
          <div className="md:flex max-w-full">
            <div>
              <h1 className="text-scogo21 2xl:text-font24 text-font16 font-medium font-rubik ">
                Projects
              </h1>
            </div>
            <div className="md:flex items-center ml-auto">
              <InputFiels
                type="text"
                inputImg="./img/search.png"
                inputClass="loginput 2xl:h-9 h-8  max-w-search-input"
                inputPlaceholder="Search"
                inputImgDiv="loginput-imgdiv top-2 left-4"
                inputDiv="loginput-maindiv mr-m-20"
                value={search.searchUser}
                onChange={handleChange}
              />

              <Buttons
                buttonClass="text-white bg-scogoprimary md:mt-0 mt-2 w-w-120 2xl:h-9 h-8 font-medium 2xl:text-font16 text-font13 flex items-center justify-center rounded-6px shadow-primaryBtnShadow"
                children="Add New"
                Btnalt=""
                btnimgClass="2xl:w-4 w-3 2xl:h-4 h-3 mr-1"
                buttonIcon="./img/plus.svg"
                onClick={viemore}
              />
            </div>
          </div>
        </div>
        <div className=" w-full z-0 2xl:px-8 xl:px-4 px-2  lg:pt-16 pt-2">
          <div className="flex-auto ">
            <div className="tab-content tab-space ">
              <div className="lg:h-75vh h-100vh lg:pb-0 md:pb-168 pb-230 overflow-auto ">
                <table className="bg-white border shadow-mainBoxShadow w-full help-table">
                  <thead className="md:flex sticky top-0  hidden p-p-15 bg-white z-40  rounded-6px table_custom_th justify-between">
                    <th className="2xl:min-w-48 2xl:w-48 lg:min-w-28 lg:w-28 md:min-w-32 md:w-32 flex items-center">
                      <Checkbox
                        checkColor="text-scogoorange mr-2"
                      />
                      ID
                    </th>
                    <th className="2xl:min-w-40 2xl:w-40 lg:min-w-24 lg:w-24 md:min-w-32 md:w-32">
                      Project Name
                      <span class="material-icons text-font10 text-scogoprimary ml-1 cursor-pointer ">
                        filter_alt
                      </span>
                    </th>
                    <th className="2xl:min-w-80 2xl:w-80 lg:min-w-48 lg:w-48 md:min-w-60 md:w-60">
                      Tickets
                    </th>
                    <th className="2xl:min-w-40 2xl:w-40 lg:min-w-24 lg:w-24 md:min-w-32 md:w-32">
                      Customer
                      <span class="material-icons text-font10 text-scogoprimary ml-1 cursor-pointer">
                        filter_alt
                      </span>
                    </th>
                    <th className="2xl:min-w-40 2xl:w-40 lg:min-w-24 lg:w-24 md:min-w-32 md:w-32">
                      Perfomance
                      <span class="material-icons text-font10 text-scogoprimary ml-1 cursor-pointer">
                        filter_alt
                      </span>
                    </th>
                    <th className="2xl:min-w-40 2xl:w-40 lg:min-w-24 lg:w-24 md:min-w-32 md:w-32">
                      SPOC Detail
                      <span class="material-icons text-font10 text-scogoprimary ml-1 cursor-pointer">
                        filter_alt
                      </span>
                    </th>
                    <th className="2xl:min-w-40 2xl:w-40 lg:min-w-24 lg:w-24 md:min-w-32 md:w-32">
                      Project detail
                      <span class="material-icons text-font10 text-scogoprimary ml-1 cursor-pointer">
                        filter_alt
                      </span>
                    </th>
                    <th className="2xl:min-w-40 2xl:w-40 lg:min-w-24 lg:w-24 md:min-w-32 md:w-32">
                      PM Detail
                      <span class="material-icons text-font10 text-scogoprimary ml-1 cursor-pointer">
                        filter_alt
                      </span>
                    </th>
                    <th className="2xl:min-w-20 2xl:w-20 lg:min-w-16 lg:w-16 md:min-w-32 md:w-32">
                      Actions

                    </th>
                  </thead>
                  <tbody>
                    <div>
                      {projectList.map((item) => (
                        <tr
                          className={`${bguser} md:flex w-full grid p-p-15 items-start relative Content justify-between`}
                        >
                          <td
                            className="2xl:min-w-48 2xl:w-48 lg:min-w-28 lg:w-28 md:min-w-32 md:w-32 cursor-pointer md:mt-0 mt-2"

                          >
                            <div className="flex items-center">
                              <p className="md:hidden block 2xl:text-font15 text-font12 font-normal text-scogogray md:mr-0 mr-3">
                                ID :
                              </p>
                              <div>
                                <Checkbox
                                  checkColor="text-scogoorange mr-2"
                                />
                              </div>
                              <div className="md:block flex items-center" onClick={openDetails}>
                                <p className="text-scogoprimary 2xl:text-font13 text-font11 font-medium" >
                                  {item.projectID}
                                </p>
                                <img src="./img/agent.svg" alt="" className="md:ml-0 ml-2" />
                              </div>
                            </div>
                          </td>

                          <td className="2xl:min-w-40 2xl:w-40 lg:min-w-24 lg:w-24 md:min-w-32 md:w-32 flex md:block text-left text-scogo15 2xl:text-font13 text-font11 font-normal md:mt-0 mt-2">
                            <p className="md:hidden block 2xl:text-font15 text-font12 font-normal text-scogogray md:mr-0 mr-3">
                              Project Name :
                            </p>
                            {item.projectName}
                          </td>
                          <td className="2xl:min-w-80 2xl:w-80 lg:min-w-48 lg:w-48 md:min-w-60 md:w-60 pr-0 md:pr-6 md:mt-0 mt-2 w-full">
                            <div className="md:block flex w-full">
                              <div>
                                <p className="md:hidden block 2xl:text-font15 text-font12 font-normal text-scogogray md:mr-0 mr-3">
                                  Progress :
                                </p>
                              </div>

                              <MultiBar
                                ticketDate={item.ticketDate}
                                totalTickets={item.totalTickets}
                                ongoin={item.ongoin}
                                hold={item.ongoin + item.hold}
                                closed={item.ongoin + item.hold + item.closed}
                                totalPercentage={item.totalPercentage}

                              />

                              {/* <div className="w-full">
                              <div className="flex justify-between">
                                <div>
                                  <p className="td_p_dark">  {item.ticketDate}</p>
                                </div>
                                <div>
                                  <p className="td_p_dark"> <span className="td_p_light"> Tickets:  </span>  {item.totalTickets}</p>
                                </div>
                              </div>


                              <div className="flex">
                                <div className="bg-scogoeee w-full relative h-2.5 rounded-md mt-1 overflow-hidden">
                                  <div style={{ width: item.ongoin }} className="bg-scogogoing absolute top-0 h-2.5  rounded-md z-20"></div>
                                  <div style={{ width: item.ongoin + item.hold }} className="bg-scogoclosed absolute top-0 h-2.5 z-10 rounded-md"></div>
                                  <div style={{ width: item.ongoin + item.hold + item.closed }} className="bg-scogoorange absolute top-0 h-2.5 z-0 rounded-md"></div>
                                </div>

                                <div>
                                  <p className="td_p_dark ml-1">{item.totalPercentage}%</p>
                                </div>
                              </div>

                              <div className="flex justify-between mt-2">
                                <div className="text-scogogray text-font11 font-normal">
                                  <span class="material-icons text-scogoorange text-font10 mr-1">
                                    circle
                                  </span>
                                  Ongoing (5)
                                </div>
                                <div className="text-scogogray text-font11 font-normal">
                                  <span class="material-icons text-scogoclosed text-font10 mr-1">
                                    circle
                                  </span>
                                  Hold(10)
                                </div>
                                <div className="text-scogogray text-font11 font-normal">
                                  <span class="material-icons text-scogo2e text-font10 mr-1">
                                    circle
                                  </span>
                                  Closed (15)
                                </div>
                              </div>
                            </div> */}
                            </div>
                          </td>
                          <td className="2xl:min-w-40 2xl:w-40 lg:min-w-24 lg:w-24 md:min-w-32 md:w-32 md:block flex  flex-wrap text-left text-scogogray 2xl:text-font13 text-font11 font-normal md:mt-0 mt-2">
                            <p className="md:hidden block 2xl:text-font15 text-font12 font-normal text-scogogray md:mr-0 mr-3">
                              Customer :
                            </p>
                            <p className="2xl:text-font13 text-font11 text-scogo15 font-medium md:mr-0 mr-2">{item.customerBank}</p>
                            <p className="2xl:text-font13 text-font11 text-scogo15 font-normal md:mr-0 mr-2">{item.customerName}</p>
                            <p className="2xl:text-font13 text-font11 text-scogogray font-normal">{item.customerNumber}</p>
                          </td>
                          <td className="2xl:min-w-40 2xl:w-40 lg:min-w-24 lg:w-24 md:min-w-32 md:w-32 text-left md:block flex  flex-wrap  text-scogogray 2xl:text-font13 text-font11 font-normal md:mt-0 mt-2">
                            <p className="md:hidden block 2xl:text-font15 text-font12 font-normal text-scogogray md:mr-0 mr-3">
                              Perfomance :
                            </p>
                            <p className="2xl:text-font13 text-font11 text-scogo15 font-normal md:mr-0 mr-2">Min: {item.performanemin}</p>
                            <p className="2xl:text-font13 text-font11 text-scogo15 font-normal md:mr-0 mr-2">Max: {item.performanemax}</p>
                            <p className="2xl:text-font13 text-font11 text-scogo15 font-normal">Avg: {item.performanemavg}</p>
                          </td>
                          <td className="2xl:min-w-40 2xl:w-40 lg:min-w-24 lg:w-24 md:min-w-32 md:w-32 text-left items-center md:block flex  flex-wrap text-scogogray 2xl:text-font13 text-font11 font-normal md:mt-0 mt-2">
                            <p className="md:hidden block 2xl:text-font15 text-font12 font-normal text-scogogray md:mr-0 mr-3">
                              SPOC Detail :
                            </p>
                            <p className="2xl:text-font13 text-font11 text-scogo15 font-normal md:mr-0 mr-2">Min: {item.spocmin}</p>
                            <p className="2xl:text-font13 text-font11 text-scogogray font-normal md:mr-0 mr-2">{item.spocNumber}</p>
                            <Buttons
                              children="Update"
                              buttonClass="bg-white md:mt-2 mt-0 border border-scogoorange px-4 2xl:h-8 h-6 leading-6 cursor-pointer text-scogoorange text-font12 font-normal rounded-5px"
                              onClick={viemore}
                            />
                          </td>
                          <td className="2xl:min-w-40 2xl:w-40 lg:min-w-24 lg:w-24 md:min-w-32 md:w-32  md:block flex flex-wrap text-left text-scogogray 2xl:text-font13 text-font11 font-normal ">
                            <p className="md:hidden block 2xl:text-font15 text-font12 font-normal text-scogogray md:mr-0 mr-3">
                              Project detail :
                            </p>
                            <p className="2xl:text-font13 text-font11 text-scogo15 font-normal">{item.ProDetails}</p>

                          </td>
                          <td className="2xl:min-w-40 2xl:w-40 lg:min-w-24 lg:w-24 md:min-w-32 md:w-32 text-left  items-center md:block flex  flex-wrap text-scogogray 2xl:text-font13 text-font11 font-normal md:mt-0 mt-2">
                            <p className="md:hidden block 2xl:text-font15 text-font12 font-normal text-scogogray md:mr-0 mr-3">
                              PM Detail :
                            </p>
                            <p className="2xl:text-font13 text-font11 text-scogo15 font-normal md:mr-0 mr-2">{item.pmName}</p>
                            <p className="2xl:text-font13 text-font11 text-scogogray font-normal">{item.pmNumber}</p>
                          </td>
                          <td className="2xl:min-w-20 2xl:w-20 lg:min-w-16 lg:w-16 md:min-w-32 md:w-32   text-left text-scogogray 2xl:text-font13 text-font11 font-normal md:relative absolute right-0 md:mt-0 mt-2">
                            <span class="material-icons text-scogoprimary text-left">
                              more_vert
                            </span>
                          </td>

                        </tr>
                      ))}
                    </div>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>



      {projectDetails && (
        <>
          <div className="lg:w-1/3 w-full pt-16 lg:relative  lg:pb-0 pb-10  bg-white -300 border-t-2 border-r-2 border-l-2 border-scogof2">
            <ProDetails projectDetails={projectDetails} closeProjectDetails={closeProjectDetails} closeProSide={closeProSide} />
          </div>
        </>
      )}
    </div>
  );
};

export default Dashboard;
